<div class="flex flex-col gap-9">
  <div class="flex flex-col gap-3">
    <div
      class="bg-grey-skeleton w-full h-[130px] animate-pulse rounded-10"
    ></div>
    <div class="flex flex-col gap-2">
      <div class="animate-pulse w-full bg-[#DDDEE0] h-[20px]"></div>
      <div class="animate-pulse w-full bg-[#DDDEE0] h-[20px]"></div>
    </div>
  </div>

  <div class="flex flex-col gap-7">
    @for (item of itemsSkel; track $index) {

    <div class="flex gap-3">
      <div
        class="w-full rounded-7 max-w-69 h-69 object-cover bg-grey-skeleton animate-pulse"
      ></div>
      <div class="flex flex-col w-full gap-2">
        <div class="animate-pulse bg-[#DDDEE0] w-full h-[20px]"></div>
        <div class="animate-pulse bg-[#DDDEE0] w-full h-[20px]"></div>
      </div>
    </div>
    }
  </div>
</div>
